<template>
  <div>
      <div class="make" v-show="tippopu">
        <div class="bag">
          <img src="static/img/loading.gif" alt="">
        </div>
      </div>    
  </div>
</template>

<script>
  export default {
    props:{
    
    },
    data () {
      return {
            tippopu:false,
      }
    },
    methods:{
        loadShow () {
           this.tippopu=true
        },
        loadclose() {
             this.tippopu=false; 
        }
    }
  }
</script>

<style scoped>
.make{
    position:fixed;
    top:0;
    left:0;
    bottom:0;
    right:0;
    /*background:rgba(0,0,0,0.2);*/
    background-color: transparent;
   /* opacity:0.8;*/
    z-index:1000;
}
.bag{
  width: 70px;
  height: 70px;
  background:rgba(0,0,0,0.5); 
  top:50%;
  left:50%;
  margin-top:-35px;
  margin-left:-35px;
  position: absolute;

}
.make img{
  width:48px;
  height:48px;
  margin-top: 11px;
  margin-left: 11px;	
}

</style>



// WEBPACK FOOTER //
// src/components/loading.vue